export default "__VITE_ASSET__b25b12b2__"